<template>
  <div class="register">
    <Header/>
    <div class="register-main">
      <form @submit.prevent class="register-form">
        <h1 class="title">Create your account</h1>
        <div class="form-body">
          <div class="item">
            <input v-model.trim='registerFormData.name' type="text" placeholder="Name (required)"/>
            <input v-model.trim='registerFormData.jobTitle' type="text" placeholder="Job Title">
            <input v-model.trim='registerFormData.company' type="text" placeholder="Company (required)"/>
            <input v-model.trim='registerFormData.email' type="email" placeholder="Email (required)"/>
            <input v-model.trim='registerFormData.password' type="password" placeholder="Password (at least 6 characters)"/>
            <label class="custom-check">
              <input type="checkbox" id='agree-terms' @change='agreeTerms'/>
              <span class="checkmark"></span>
              <p>I agree to the <router-link to="/"> <a>terms of use</a> </router-link> and our <router-link to="/"> <a>privacy policy</a> </router-link>.</p>
            </label>
          </div>
          <div class="item">
            <h2>What do you want to use ROSE for?</h2>
            <div class="radio-group">
              <label class="custom-check">
                <input type="checkbox" name="rose-use" @change="changeActiveOption" value='Track License Expirations'/>
                <span class="checkmark"></span>
                <p>Track License Expirations</p>
              </label>
              <label class="custom-check">
                <input type="checkbox" name="rose-use" @change="changeActiveOption" value='Research Predicate Devices'/>
                <span class="checkmark"></span>
                <p>Research Predicate Devices</p>
              </label>
              <label class="custom-check">
                <input type="checkbox" name="rose-use" @change="changeActiveOption" value='Track Competitors'/>
                <span class="checkmark"></span>
                <p>Track Competitors</p>
              </label>
              <label class="custom-check">
                <input type="checkbox" name="rose-use" @change="changeActiveOption" value='Lookup International Classifications'/>
                <span class="checkmark"></span>
                <p>Lookup International Classifications</p>
              </label>
              <label class="custom-check">
                <input type="checkbox" name="rose-use" @change="changeActiveOption" value='Explore International Markets'/>
                <span class="checkmark"></span>
                <p>Explore International Markets</p>
              </label>
            </div>
          </div>
        </div>
        <button @click="register" class="orange-btn">Create Account</button>
        <span class="register-errors">Errors</span>
        <p class="login">Already a member? <router-link to="/login"> <a>Log In</a> </router-link></p>
      </form>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/layout/header.vue';
import {axiosClient} from "@/axios-client";
import router from '@/router/';
import {auth} from "@/store/firebase";
import Footer from '@/components/layout/footer.vue';

export default {
  name: "register",
  components: {
    Header,
    Footer
  },

  data() {
    return {
      isAgreeChecked: false
    }
  },

  methods: {
    changeActiveOption(e) {
      let value = e.target.value;
      let inputDesc = e.target.nextSibling.nextSibling;
      inputDesc.classList.toggle('active-check');

      if(inputDesc.classList.contains('active-check')) {
        this.registerFormData.usages.push(value);
      } else {
        this.registerFormData.usages.pop(value);
      }
    },

    agreeTerms() {
      let isAgreeChecked = document.querySelector('#agree-terms').checked;

      if(isAgreeChecked) {
        this.isAgreeChecked = true;
      } else {
        this.isAgreeChecked = false;
      }
    },

    register() {
      // this.$store.dispatch('signup', {
      //   email: this.registerFormData.email,
      //   password: this.registerFormData.password,
      //   name: this.registerFormData.name,
      //   title: this.registerFormData.jobTitle,
      //   company: this.registerFormData.company,
      //   usages: this.registerFormData.usages,
      // })
      let errsFrame = document.querySelector('span.register-errors');

      if(this.isAgreeChecked) {
        axiosClient.post('/v1/account', {
          "displayName": this.registerFormData.name,
          "jobTitle": this.registerFormData.jobTitle,
          "company": this.registerFormData.company,
          "email": this.registerFormData.email,
          "password": this.registerFormData.password,
          "agreedToTerms": true,
          "usages": this.registerFormData.usages,
        })
            .then(({data: {loginToken}}) => auth.signInWithCustomToken(loginToken))
            // Using setTimeout here will give the onAuthStateChange callback an opportunity to run before we transition to the next view.
            .then(() => setTimeout(() => router.push('/search'),0))
            .then(function(error){
              // switch(error.code) {
              //   default: {
              //     errsFrame.innerHTML = 'Something went wrong.';
              //     errsFrame.style.visibility = 'initial';
              //     break;
              //   }

              //   case 'auth/weak-password': {
              //     errsFrame.innerHTML = 'Password should be longer than 6 characters.';
              //     errsFrame.style.visibility = 'initial';
              //     break;
              //   }

              //   case 'auth/invalid-email': {
              //     errsFrame.innerHTML = 'Email is not in correct format.';
              //     errsFrame.style.visibility = 'initial';
              //     break;
              //   }
              // }
            })
        ;
      } else {
        document.querySelector('.register-errors').innerHTML = 'Please agree to our terms of use and privacy policy.';
        document.querySelector('.register-errors').style.visibility = 'initial';

      }
    }
  },

  data() {
    return {
      registerFormData: {
        name: '',
        jobTitle: '',
        company: '',
        email: '',
        password: '',
        usages: [],
      }
    }
  }
};
</script>

<style lang="scss">
  .register-main {
    height: 100vh;
    width: initial;
    display: flex;
    justify-content: center;
    background: #f9f9f9;

    form.register-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      padding: 50px 65px;
      box-shadow: 0px 4px 35px rgba(51, 51, 51, 0.06);
      border-radius: 10px;
      align-self: flex-start;
      margin-top: 100px;
      min-width: 880px;
      width: 50%;

      h1.title {
        font-family: "Gotham-Medium";
        margin-bottom: 45px;
      }

      .form-body {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .item {
          width: 47%;
          display: flex;
          flex-direction: column;

          &:first-of-type {
            .custom-check {
              p {
                padding-left: 32px;

                a a {
                  color: #FCAF05;
                  font-family: "Gotham-Medium";
                  text-decoration: underline;
                }
              }

              .checkmark {
                top: 4px;
              }
            }
          }

          &:last-of-type {
            h2 {
              font-size: 18px;
              line-height: 29px;
              margin-bottom: 40px;
            }

            label.custom-check {
              margin-bottom: 30px;

              .checkmark {
                top: 4px;
              }

              p {
                margin: 0;
                padding-left: 33px;

                &.active-check {
                  color: #FCAF05;
                  font-family: 'Gotham-Medium';
                }
              }
            }
          }

          input {
            width: 100%;
            border: 1px solid #CDCDCD;
            border-radius: 10px;
            color: #333;
            font-size: 14px;
            line-height: 13px;
            padding: 16px 20px;
            margin-bottom: 20px;

            &::placeholder {
              color: #676868;
            }

            &:focus {
              outline: none;
            }
          }
        }
      }

      button.orange-btn {
        border: none;
        width: 330px;
        margin: 10px 0;

        &:focus {
          outline: none;
        }
      }

      span.register-errors {
        font-size: 14px;
        color: #f26464;
        visibility: hidden;
      }

      p.login {
        margin-top: 33px;

        a a {
          color: #FCAF05;
        }
      }
    }
  }
</style>